import { isInternalUserEmail } from '#pplx/frontend/auth/internalUser.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { setCookieHasPreviouslyLoggedIn } from '#pplx/frontend/cookies/metadataCookieManager.js';
import { useEffect } from 'react';
export function useIsInternalUser() {
    const { session } = useSession();
    return isInternalUserEmail(session?.user?.email);
}
export function useIsUserLoggedIn() {
    const { status } = useSession();
    const isLoggedIn = status === 'authenticated';
    useEffect(() => {
        if (isLoggedIn) {
            setCookieHasPreviouslyLoggedIn();
        }
    }, [isLoggedIn]);
    return isLoggedIn;
}
export function useIsUserLoggedInLoading() {
    const { status } = useSession();
    return status === 'loading';
}
//# sourceMappingURL=userHooks.js.map